import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { ModalController } from '@ionic/angular';
import { filter, takeUntil } from 'rxjs/operators';

import * as fromActions from 'app/core/store/actions/auth.actions';
import { AuthState } from 'app/core/store/reducers/auth.reducer';
import * as rootReducer from 'app/core/store';
import { ToastService } from 'app/core/services/toast.service';
import { VALIDATION_REGEXP } from 'app/shared/constants/app-service-constants';
import { EmailValidatorComponent } from './email-validator.component';
import { ValidationMessages } from '../modal-registration/modal-registration.constants';
import { FormValidator } from '../form-validator';

@Component({
  standalone: false,
  selector: 'pptl-forgot-pass',
  templateUrl: './modal-forgot-pass.component.html',
  styleUrls: ['./modal-forgot-pass.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalForgotPassComponent implements OnDestroy {
  emailFormGroup: FormGroup;
  readonly validationMessages = ValidationMessages;
  loaded = false;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private toastService: ToastService,
    private formBuilder: FormBuilder,
    public modalController: ModalController,
    private store: Store<rootReducer.State>,
  ) {
    this.emailFormGroup = this.formBuilder.group(
      {
        emailAddress: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(VALIDATION_REGEXP.SIMPLE_EMAIL),
          ]),
        ],
        confirmEmailAddress: [
          '',
          Validators.compose([Validators.required, EmailValidatorComponent.emailCompareControl]),
        ],
      },
      {
        validator: EmailValidatorComponent.emailCompare.bind(this),
      },
    );
  }

  ngOnDestroy() {
    this.loaded = false;
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onCloseButtonClick() {
    this.modalController.dismiss();
  }

  async onSubmitButtonClick() {
   this.store.dispatch(fromActions.RestorePassword({ payload: this.emailFormGroup.value }));
    this.onSubmitSuccessSubscribe();
    this.onErrorSubscribe();
  }

  getClass(controlName: string, errorType: string): string {
    return FormValidator.getValidClass(controlName, errorType, this.emailFormGroup);
  }

  private onErrorSubscribe(): void {
    this.store
      .pipe(
        select(rootReducer.getAuthError),
        filter((state: any) => state && state.errorMessage),
        takeUntil(this.destroy$),
      )
      .subscribe((state: any) => {
        this.toastService.showToast(state.errorMessage);
        this.modalController.dismiss();
      });
  }

  private onSubmitSuccessSubscribe(): void {
    this.store
      .pipe(
        select(rootReducer.selectAuth),
        filter((state: AuthState) => state.loaded),
        takeUntil(this.destroy$),
      )
      .subscribe((state: AuthState) => {
        this.loaded = state.loaded;
      });
  }
}
